import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-product-redirect-loader',
  templateUrl: './product-redirect-loader.component.html',
  styleUrls: ['./product-redirect-loader.component.scss']
})
export class ProductRedirectLoaderComponent implements OnInit, OnDestroy {

  private fallbackTimer: any = null;

  constructor(private router: Router) { }

  ngOnInit() {
    //PortalComponent normally moves us off this route as soon as the store's
    //subscriptions load. Store switching now depends on that, so if the partner
    //detail call fails the user would sit on this spinner indefinitely.
    this.fallbackTimer = setTimeout(() => {
      if (this.router.url.toLocaleLowerCase().indexOf('product-redirect-loader') > -1) {
        this.router.navigateByUrl('store/calendar');
      }
    }, 15000);
  }

  ngOnDestroy() {
    if (this.fallbackTimer) {
      clearTimeout(this.fallbackTimer);
    }
  }

}
